<script setup lang="ts">
  import type { PopoverTriggerProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { PopoverTrigger, useForwardProps } from 'reka-ui'
  import { cn } from '@rapoo/element/lib/utils'

  const props = defineProps<PopoverTriggerProps & { class?: HTMLAttributes['class'] }>()

  const delegatedProps = reactiveOmit(props, 'class')
  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <PopoverTrigger
    v-bind="forwardedProps"
    :class="
      cn('inline-flex items-center cursor-pointer justify-center whitespace-nowrap', props.class)
    "
  >
    <span class="truncate">
      <slot />
    </span>
  </PopoverTrigger>
</template>
